import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const BtnContainer = styled('div')`
  display: flex;
  justify-content: center;  
  @media screen and (max-width: 600px) {
    margin: 10px 30px;
  }
`;

const HeaderWrapper = styled('div')`
  margin: 0 0 20px;
`;

const IntroWrapper = styled('div')`
  margin: 20px 0;
`;

const Ack = styled('div')`
  text-align: left;
`;

const AckInner = styled('div')`
  padding: 20px;
`;

const AckInnerLabel = styled('div')`
  font-size: 3rem;
  line-height: 1.2;

  .space-below {
    margin-below: 20px;
  }
`;

const AckLogoContainer = styled('div')`
  display: flex;
  justify-content: center;
  height: 1.8cm;
`;

const AckLogo = styled(Svg)`
  width: 350px;
  height: 200px;
`;

const RedFont = styled('font')`
  color: red;
`;

const PictureAttachment = styled('div')`
  width: 30%;
  margin-bottom: 20px;

  @media (max-width: 1200px) {
    width: 42%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const AudioAttachment = styled('div')`
  margin: 20px 0px 20px 0px;
  display: inline-flex;

  p {
    margin-right: 20px;
  }

  @media (max-width: 1200px) {
    display: block;
    margin-top: 5em;
  }
  audio {    
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
`;

const QuestionNumber = styled('span')`
  font-size: 16px;
  margin-right: 5px;
`;

export default {
  BtnContainer,
  HeaderWrapper,
  IntroWrapper,
  Ack,
  AckInner,
  AckLogoContainer,
  AckLogo,
  RedFont,
  AckInnerLabel,
  PictureAttachment,
  AudioAttachment,
  QuestionNumber,
};
